import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { DisplayService } from '../../services/display/display.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { CommsService } from '../../services/comms/comms.service';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
@Component({
	selector: 'pcm-page-po-replacement',
	templateUrl: './page-po-replacement.html',
	styleUrls: ['./page-po-replacement.scss']
})
export class PagePoReplacementComponent implements OnInit {
	public title = 'Replacement Purchase Order';
	public dataConfig;
	private dataObj = this.configService.purchaseOrderDataObj;
	public activePO;
	public replacedPO;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private configService: ConfigService,
		private dataService: DataService,
		private contractorService: ContractorService,
		private displayService: DisplayService,
		private timesheetService: TimesheetService,
		private smartContractService: SmartContractService,
		private commsService: CommsService,
		private purchaseOrderService: PurchaseOrderService
	) { }

	ngOnInit() {
		this.dataConfig = this.configService.getDataObj(this.dataObj);
		this.activePO = this.purchaseOrderService.selectedPO;
		this.getReplacedPO();
	}

	getReplacedPO() {
		this.commsService.getPODetails(this.activePO.prevponum, this.activePO.supplierid).subscribe((res) => {
			this.displayService.endLoading();
			this.replacedPO = res.detail;
		}, (err) => {
			this.displayService.endLoading();
		});
	}

	backToPO() {
		this.purchaseOrderService.openPO(this.activePO.ponumber, this.activePO.supplierid);
	}

}
